<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#FDAC53"
      spinner="bar-fade-scale"
    />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showSnackBar" color="#FDAC53" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left align-self-center>{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap justify-center>
      <v-flex xs12 align-self-center>
        <v-img
          cover
          class="align-center"
          :src="require('./../../assets/images/Group26.png')"
        >
          <v-layout wrap px-2 px-sm-16 pt-4 pt-lg-0>
            <v-flex xs12 md12 lg12 px-lg-12>
              <v-layout wrap>
                <v-flex xs12 align-self-center text-left>
                  <span class="title1">What is</span>
                </v-flex>
                <v-flex xs12 align-self-center text-left>
                  <span
                    :class="
                      $vuetify.breakpoint.name == 'md'
                        ? 'title2md'
                        : $vuetify.breakpoint.name == 'xs'
                        ? 'title2xs'
                        : 'title2'
                    "
                    >Tigerthon?</span
                  >
                </v-flex>
                <v-flex xs12 sm12 md12 lg12 align-self-center text-justify py-4>
                  <span class="title3">
                    Tigerthon is a technology hackathon where technology experts
                    from around the world will converge virtually to develop a
                    prototype or wireframe as a tech solution to enable
                    enforcement authorities to monitor and manage illegal
                    wildlife trade incidents, with a particular focus on tiger
                    related crimes in tiger range countries around the world.
                    Tigerthon is scheduled to take place between 30-31 October
                    2021.
                  </span>
                </v-flex>
                <!-- <v-flex xs12 lg6 align-self-center text-left py-4>
                  <a target="_blank" href="https://forms.gle/mVhPFTSvGSAM2bLEA">
                    <v-btn
                      style="border: 1px solid #e08c1d"
                      rounded
                      plain
                      outlined
                      :width="$vuetify.breakpoint.name == 'xs' ? '100%' : '50%'"
                    >
                      <span class="title4"> APPLICATION LINK </span>
                    </v-btn></a
                  >
                </v-flex> -->
              </v-layout>
            </v-flex>
            <!-- <v-flex
              xs12
              md6
              lg6
              pl-lg-16
              px-lg-12
              px-lg-0
              pt-12
              pt-lg-14
              pt-xl-16
            >
              <v-layout wrap pl-lg-12 align-self-end>
                <v-flex  pt-lg-16
                  xs12
                  align-self-center
                  text-justify
                  pl-md-4
                  pl-lg-0
                  px-lg-12
                  py-4
                  pt-xl-12
                >
                  <span  class="title5">
                   
                    #SAVETHESTRIPES
                  </span>
                </v-flex>
                <v-flex
                  xs12
                  pl-md-4
                  pl-lg-0
                  px-lg-12
                  py-4
                  pt-10
                  text-justify
                  align-self-center
                >
                  <span class="title6"
                    >Develop a Global Database and Mobile App: A centralized
                    database which will gather information about tiger related
                    crimes viz., poaching, killing, trafficking of tiger body
                    parts, keeping tigers as pets illegally, illegal farming for
                    commercial purposes and also online incidents where Illegal
                    Wildlife Trade is indicated or facilitated. 
                  </span>
                </v-flex>
                <v-flex
                  xs12
                  pl-md-4
                  pl-lg-0
                  px-lg-12
                  py-4
                  text-left
                  align-self-center
                >
                  <span class="title6">

                    <br />
                    <br />
                  </span>
                </v-flex>
              </v-layout>
            </v-flex> -->
          </v-layout>
        </v-img>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  data() {
    return {
      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,
      vdo: ["./../../assets/videos/Tigers.mp4"],
    };
  },
};
</script>
